<template>
  <div class="advance-filter-panel">
    <DxToolbar class="split-view-toolbar" v-if="toolbarVisible">
      <dx-item
        location="before"
        widget="dxTabs"
        :options="filterPanelTabOptions"
        :selected-index.sync="sidebarTabSelectedIndex"
      ></dx-item>

      <DxItem :options="toolbar.close" location="after" widget="dxButton" />
    </DxToolbar>

    <div v-show="sidebarTabSelectedIndex == 0">
      <div class="view-card responsive-paddings">
        <div class="advance-filter-header-btns">
          <DxButton
            class="apply-btn"
            :text="applyButtonLabel"
            type="default"
            @click="checkValidation"
          />
          <DxButton text="reset" type="normal" @click="clearFilter" />
        </div>

        <div class="filter-form">
          <gc-form
            :formOptions="formOptions"
            :formItems="formItems"
            :valueChangeCallBack="
              formLocation == 'form-report'
                ? formFilterCallBack
                : fieldValueChange
            "
            :triggerClear="isClear"
            :formHeight="getFilterFormHeight"
            :formLocation="formLocation"
            :checkValid="isValid"
            :isFilterForm="true"
            @applyDefaultFilters="setDefaultValueFilters"
            :formMode="'filter-mode'"
            :validationGroup="filterValidationGroup"
            v-if="getFilterFormHeight && refreshForm"
            :persistenceKey="persistenceKey"
            :isNormal="isNormal"
            :onFormEnterKey="checkValidation"
            :ref="'gc-form'"
            :onFormKeypress="onFormKeypress"
          ></gc-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { DataGridState } from "../_models/data-grid-state";
import { CommonStorage } from "../_services/storage";
export default {
  mixins: [],
  components: {},
  props: {
    overWriteClear: {
      type: Boolean,
      default: false,
    },
    isNormal: {
      type: Boolean,
      default: false,
    },
    toolbar: {
      type: Object,
      default: () => {},
    },
    toolbarVisible: {
      type: Boolean,
      default: true,
    },

    formItemData: {
      type: [Object, Array],
      default: () => {},
    },
    formHeight: {
      type: [Number, String],
      default: "auto",
    },
    formLocation: {
      type: String,
      default: "grid-report",
    },
    setFilterValues: {
      type: Function,
      default: () => function () {},
    },
    setGridPanelFilter: {
      type: Function,
      default: () => function () {},
    },
    gridFoolter: {
      type: Boolean,
      default: false,
    },
    persistenceKey: {
      type: String,
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    getGridInstance: {
      type: Function,
      default: () => {},
    },
    from: {
      type: String,
      default: "filter-panel",
    },
    heightAdjustment: {
      type: Number,
      default: 0,
    },
    clearFilterForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formOptions: {
        gcLabelLocation: "top",
      },
      sidebarTabSelectedIndex: 0,
      dirty: {
        isDirty: false,
      },
      filterCollection: [],
      isClear: false,
      isValid: false,
      filterFormHeight: undefined,
      refreshForm: true,
      instanceId: new Date().getTime(),
    };
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ headerFormHeight: "ui/getHeaderFormHeight" }),
    getGridHeight() {
      if (this.headerFormHeight) return this.gridHeight - this.headerFormHeight;
      else return this.gridHeight;
    },
    getFilterFormHeight() {
      if (this.from !== "model")
        return (
          this.getGridHeight -
          59 -
          (this.headerFormHeight ? 45 : 55) -
          (this.gridFoolter ? 45 : 10) +
          (this.from == "transaction-list-grid" ? 10 : 0) +
          (this.from == "grid-report-grid" ? 10 : 0) +
          (this.from == "split-view-grid" ? 10 : 0) +
          (!this.toolbarVisible ? 5 : 0) -
          (this.from == "transaction-screen" ? 20 : 0) -
          (this.from == "stand-alone" ? 60 : 0) -
          this.heightAdjustment
        );
      else {
        return this.heightAdjustment - 93;
      }
    },
    filterValidationGroup() {
      return "filter-panel-form-" + (this.persistenceKey || this.instanceId);
    },
    applyButtonLabel() {
      if (this.dirty.isDirty) {
        return "Apply";
      } else {
        return "Refresh";
      }
    },

    filterPanelTabOptions() {
      return {
        dataSource: [
          {
            id: 0,
            text: "Filters",
          },
        ],
        selectedIndex: this.sidebarTabSelectedIndex,
      };
    },
    formItems() {
      if (this.persistenceKey)
        return DataGridState.setFilterData(this.persistenceKey, [
          ...this.formItemData,
        ]);
      else return [...this.formItemData];
    },
  },
  created() {},

  methods: {
    onFormKeypress(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
      }
    },
    checkValidation() {
      this.isValid = true;
    },
    async clearFilter() {
      this.$store.dispatch("dataContext/setAdvanceFilterApplied", false);
      if (this.persistenceKey) {
        this.showLoading(true);
        await DataGridState.removeState(this.persistenceKey);

        CommonStorage.saveItems("remove_state", true);
        CommonStorage.clear("filter-panel-" + this.persistenceKey);
        CommonStorage.clear(this.persistenceKey);
        CommonStorage.clear(this.persistenceKey + "-scroll-offset");

        if (this.overWriteClear) {
          this.filterCollection = [];
          this.setGridPanelFilter([], true);
        }

        setTimeout(() => {
          if (this.overWriteClear) {
            this.isClear = true;
          } else this.$router.go(this.$router.current);
          // this.isClear = true;
        }, 500);
      } else {
        this.isClear = true;
      }
    },
    applyFilter(applyButtonLabel) {
      this.$store.dispatch("dataContext/setAdvanceFilterApplied", true);
      this.isClear = false;
      this.isValid = false;
      if (this.formLocation != "form-report") {
        this.setGridPanelFilter(this.filterCollection, true, applyButtonLabel);
      } else {
        this.formFilterCallBack("apply", []);
      }
      this.$nextTick(() => {
        this.dirty.isDirty = false;
      });
    },
    fieldValueChange(dataField, filter, type) {
      if (dataField == "isValid" && filter == false) {
        this.isValid = false;
        return;
      }

      const applyButtonLabel = JSON.parse(
        JSON.stringify(this.applyButtonLabel),
      );

      this.dirty.isDirty = true;

      if (this.filterCollection.length > 0) {
        let index = this.filterCollection.findIndex(
          (x) => x[0][0] == dataField,
        );

        // detect parent child relationship filter removal
        // e.g MaterialDataList/MaterialCode is the dataField definition
        // filter is applied as MaterialDataList/any(i: i/MaterialCode eq 'value')
        if (dataField.includes("/")) {
          // split dataField by '/'
          const dataFieldParts = dataField.split("/");

          // find index of an item that starts with a specified string
          index = this.filterCollection.findIndex((x) =>
            x[0][0].startsWith(dataFieldParts[0] + "/any("),
          );
        }

        if (index > -1) {
          if (this.filterCollection[index + 1] == "and") {
            this.filterCollection.splice(index, 2);
          } else {
            this.filterCollection.splice(index, 1);
          }
        }
        // after the splice event

        if (
          this.filterCollection.length > 0 &&
          this.filterCollection[this.filterCollection.length - 1] != "and"
        )
          this.filterCollection.push("and");
      }

      if (filter && type == "Text") {
        this.filterCollection.push([[dataField, "contains", filter]]);
      } else if (
        typeof filter === "number" &&
        (Number.isInteger(filter) || Number(filter).isFloat())
      ) {
        if (type === "Comma") {
          this.filterCollection.push([[dataField, "contains", `,${filter},`]]);
        } else {
          this.filterCollection.push([[dataField, "=", filter]]);
        }
      } else if (filter && filter.length > 0) {
        this.filterCollection.push(filter);
      }

      if (this.filterCollection[this.filterCollection.length - 1] == "and") {
        this.filterCollection.splice(this.filterCollection.length - 1, 1);
      }

      if (dataField == "clear") {
        this.filterCollection = [];
        this.applyFilter();
      }
      if (dataField == "apply") {
        this.applyFilter(applyButtonLabel);
      }
    },
    formFilterCallBack(dataField, value) {
      this.isValid = false;
      this.isClear = false;
      this.setFilterValues(dataField, value);

      if ((dataField == "isValid" && value == false) || dataField == "clear") {
        this.$store.dispatch("dataContext/setAdvanceFilterApplied", false);
        this.dirty.isDirty = false;
      } else {
        this.$store.dispatch("dataContext/setAdvanceFilterApplied", true);
        this.dirty.isDirty = true;
      }
    },
    setDefaultValueFilters() {
      // if (this.filterCollection.length > 0) {
      this.setGridPanelFilter(this.filterCollection);
      // }
    },
  },
  watch: {
    from: {
      handler() {
        this.refreshForm = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.refreshForm = true;
          }, 200);
        });
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.advance-filter-header-btns {
  padding-bottom: 5px;
  .apply-btn {
    margin-right: 5px;
  }

  .dx-button {
    width: calc(50% - 3px);
  }
}
.split-view-toolbar {
  margin-top: 2px;
}
.view-card {
  margin: 0 !important;
}

.advance-filter-panel {
  .dx-form .dx-scrollable-container {
    margin-left: 0;
    padding-left: 0;
    .dx-scrollable-content {
      .dx-layout-manager.dx-widget {
        padding-right: 0;
      }
    }
  }
}
</style>
